import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'simpayx-navigate',
  templateUrl: './navigate.component.html',
  styleUrls: ['./navigate.component.scss'],
})
export class NavigateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.location.href = "https://customerapp.simpayx.com/simpayx/customer";
  }

}
